import { usePage } from "@inertiajs/react"

/**
 * The browser-exposed dev key for the public helper API endpoints, shared from
 * the server via Inertia props (see App\Http\Middleware\HandleInertiaRequests)
 * so it is never hardcoded in the JS source.
 */
export default function useDevKey() {
    return usePage().props?.devKey
}
